import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { useDrawerContext } from "./drawer";

export interface DrawerHeaderProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export default function DrawerHeader(props: Readonly<DrawerHeaderProps>) {
  const { className, children, ...rest } = props;
  const { open, float } = useDrawerContext();

  return (
    <div
      {...rest}
      className={twMerge(
        clsx("sticky top-0 left-0 bg-secondary-dark !pb-0", {
          "p-3": open || float,
          "p-2": !open && !float,
        }),
        className
      )}
    >
      {children}
    </div>
  );
}
